import { useCallback } from "react";

import { Stack, VcsProvider } from "types/generated";

import { isTrackedCommitOutdated } from "../utils";
import useHasStackWriteAccess from "./useHasStackWriteAccess";

const useCanSyncCommit = (): ((stack: Stack) => boolean) => {
  const hasStackWriteAccess = useHasStackWriteAccess();

  return useCallback(
    (stack: Stack) => {
      if (!stack) {
        return false;
      }

      const isRawGitProvider = stack.provider === VcsProvider.Git;

      return (isTrackedCommitOutdated(stack) || isRawGitProvider) && hasStackWriteAccess(stack);
    },
    [hasStackWriteAccess]
  );
};

export default useCanSyncCommit;
